const Layout = () => import(/* webpackChunkName: "Eshop" */ "../views/Layout.vue");
const Eshop = () => import(/* webpackChunkName: "Eshop" */ "../views/eshop/Index.vue");
const GoodInfo = () => import(/* webpackChunkName: "Eshop" */ "../views/eshop/GoodInfo.vue");
const SearchResult = () => import(/* webpackChunkName: "Eshop" */ "../views/eshop/SearchResult.vue");
const ConfirmOrder = () => import(/* webpackChunkName: "Eshop" */ "../views/eshop/ConfirmOrder.vue");
const ShopCart = () => import(/* webpackChunkName: "Eshop" */ "../views/eshop/ShopCart.vue");
const PayWay = () => import(/* webpackChunkName: "Eshop" */ "../views/eshop/PayWay.vue");
const PayResult = () => import(/* webpackChunkName: "Eshop" */ "../views/eshop/PayResult.vue");
const ActList = () => import(/* webpackChunkName: "Eshop" */ "../views/eshop/ActList.vue");
export default [
  {
    path: "/e-shop",
    component: Layout,
    meta: {
      title: "商城",
      titleEn: "E-Shop",
    },
    children: [
      {
        path: "",
        component: Eshop,
      },
      {
        path: "good-info",
        component: GoodInfo,
      },
      {
        path: "search-result",
        component: SearchResult,
      },
      {
        path: "confirm-order",
        component: ConfirmOrder,
        meta: {
          auth: true
        }
      },
      {
        path: "shop-cart",
        component: ShopCart,
        meta: {
          auth: true
        }
      },
      {
        path: "pay-way",
        component: PayWay,
        alias: "/home/pay-way",
        meta: {
          auth: true
        }
      },
      {
        path: "pay-result",
        component: PayResult,
        meta: {
          auth: true
        }
      },
      {
        path: "act-list",
        component: ActList,
      },
    ],
  },
];
